import { For, Show } from "solid-js";
import { CrudCollectionPage, type CrudRecord } from "./CrudCollectionPage";

export function PropertiesPage() {
  return (
    <CrudCollectionPage
      label="Properties"
      singular="Property"
      endpoint="/properties"
      icon="document_key"
      canUpdate={false}
      advancedSearch={false}
      fields={[
        { key: "id", label: "Property ID", readOnly: true },
        { key: "name", label: "Street", readOnly: true },
        { key: "ownerName", label: "Owner", readOnly: true },
      ]}
      itemTitle={(item) => value(item.name).split(",").join(", ")}
      renderAfterFields={(item) => <PropertyRelations item={item} />}
    />
  );
}

function PropertyRelations(props: { item: CrudRecord }) {
  const keyholders = Array.isArray(props.item.keyholders)
    ? (props.item.keyholders as CrudRecord[])
    : [];
  const logs = Array.isArray(props.item.logs)
    ? (props.item.logs as CrudRecord[])
    : [];
  return (
    <div class="grid grid-cols-1 gap-4 lg:grid-cols-2">
      <section class="bg-[rgba(255,255,255,.04)] p-3">
        <p class="mb-2 roboto500">Keyholders</p>
        <Show
          when={keyholders.length}
          fallback={<p class="text-sm text-white-35">No keyholders.</p>}
        >
          <For each={keyholders}>
            {(item) => (
              <div class="item-list-bg mb-2 bg-gray-gradient px-3 py-2">
                <p>{`${value(item.firstName)} ${value(item.lastName)}`}</p>
                <p class="text-xs text-white-55">
                  CID: {value(item.characterId)}
                </p>
              </div>
            )}
          </For>
        </Show>
      </section>
      <section class="bg-[rgba(255,255,255,.04)] p-3">
        <p class="mb-2 roboto500">Property Logs</p>
        <Show
          when={logs.length}
          fallback={<p class="text-sm text-white-35">No property logs.</p>}
        >
          <For each={logs}>
            {(item) => (
              <div class="item-list-bg mb-2 bg-gray-gradient px-3 py-2">
                <p>{value(item.action)}</p>
                <p class="text-xs text-white-55">
                  {value(item.actor)} • {date(item.createdAt)}
                </p>
              </div>
            )}
          </For>
        </Show>
      </section>
    </div>
  );
}

function value(input: unknown): string {
  return typeof input === "string" || typeof input === "number"
    ? String(input)
    : "";
}
function date(input: unknown): string {
  const timestamp = value(input);
  return timestamp ? new Date(timestamp).toLocaleString() : "";
}
